<template>
  <v-row>

    <v-col cols="12" class="pt-2">
      <v-sheet
        class="content-editor"
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">

            <v-switch
              v-model="enable_contact_section_landing"
              label="Habilitar boton de contacto"
            ></v-switch>
          </v-col>

          <v-col
            cols="12">
            <v-text-field
              outlined
              v-model="number_contact_landing"
              label="Número de whatsapp"
              required
            ></v-text-field>

            <v-text-field
              outlined
              v-model="text_contact_landing"
              :counter="100"
              label="Texto mensaje"
              required
            ></v-text-field>

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'customizationLanding' }"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateContactLanding()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'customizationContactSection',
    data: () => ({
      loading:true,
      loading_update: false,
      landing: [],
      enable_contact_section_landing:false,
      number_contact_landing:'',
      text_contact_landing:'',
      error:false,
      errors:[],
    }),

    methods:{
      async getCustomization(){
        await axios.get('admin/landing').then(response =>{
          this.landing = response.data.data.landing
          this.enable_contact_section_landing = (this.landing.enable_contact_section_landing)?true:false
          this.number_contact_landing = this.landing.number_contact_landing

          this.text_contact_landing = (this.landing.text_contact_landing!=null)?this.landing.text_contact_landing:''

          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async updateContactLanding(){
        this.loading_update=true
        let formData= new FormData()
        formData.append('enable_contact_section_landing', (this.enable_contact_section_landing)?1:0)
        formData.append('number_contact_landing', this.number_contact_landing)
        formData.append('text_contact_landing', this.text_contact_landing)

        try {
          await axios({
            method: 'post',
            url: 'admin/landing/contact-section',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.loading_btn = false
            this.$router.push({ name: 'customizationLanding' })
          })
        } catch (error) {
          console.log('Response: ')
          console.error(error.response.data);
        }
      }
    },

    created(){
      this.getCustomization()
    },
  }
</script>
